import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
        // server: 'https://beta.api.cocorobo.cn/api/',

const store = new Vuex.Store({
    state: {
        api: '',
        function:'',
        userId:'',
        userName:'',
        server: 'https://beta.api.cocorobo.cn/api/',
        edu: 'https://api.edu.cocorobo.cn/edu/',
        // server: 'http://localhost:8083/api/',
    },

    mutations: {
        update(state, [key, value]) {
            state[key] = value;
        },
    }
})

export default store


// WEBPACK FOOTER //
// ./src/config/config.js